import { useEffect, useRef, useState } from 'react';

export function useMaxRowHeights(rowCount: number) {
    const rowRefs = useRef<(HTMLDivElement | null)[][]>([]); // [ [col0_row0, col0_row1], [col1_row0, col1_row1], ... ]
    const [rowHeights, setRowHeights] = useState<number[]>([]);

    useEffect(() => {
        const maxHeights: number[] = [];

        for (let row = 0; row < rowCount; row++) {
            let max = 0;
            for (let col = 0; col < rowRefs.current.length; col++) {
                const el = rowRefs.current[col]?.[row];
                if (el) {
                    max = Math.max(max, el.offsetHeight);
                }
            }
            maxHeights[row] = max;
        }

        setRowHeights(maxHeights);
    }, [rowRefs.current.length]);

    const registerRef = (colIndex: number, rowIndex: number) => (el: HTMLDivElement | null) => {
        if (!rowRefs.current[colIndex]) rowRefs.current[colIndex] = [];
        rowRefs.current[colIndex][rowIndex] = el;
    };

    return { rowHeights, registerRef };
}